<script lang="ts">
  export let points;
</script>

<div class="mx-auto w-full flex justify-center">
  <section class="bg-gray-100 w-full md:w-[600px] rounded-xxl break-words">
    <ul class="text-gray-600 list-none pl-4 ml-[-1rem]">
      {#each points as point}
        <li class="text-gray-600 text-left border-b border-solid border-[#ccd5df] last:border-none">
          <p class="py-5 px-8 text-gray-600 font-medium text-md lg:text-lg tick">
            {point}
          </p>
        </li>
      {/each}
    </ul>
  </section>
</div>

<style>
  .tick::before {
    content: '\2713';
    display: inline-block;
    padding-right: 1rem;
    width: 25px;
    height: 25px;
  }
</style>
